import * as React from 'react';
import 'react-table/react-table.css'
import * as TableStyles from '../styles/TableFormats'
import { Header } from '../components/header';
import { AddUserModal } from '../modals/modal-AddUser';
import { userInfo, DropdownList, getDefaultUserInfo, orgInfo, orgTypes, registerUserInfo } from '../api/dataTypes';
import ReactTable from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
// import { EditUserModal } from 'src/modals/modal-edit-user';
// import { isCustomerRole, USER_ROLE, isAdminRole, isOwnerRole, isRoleSubordinate } from 'src/api/auth-api';
// import { getOrgCustomersListApi, getCustomersListApi } from 'src/api/api-customers';
import matchSorter from 'match-sorter';
import * as userApi from '../api/api-user';
import { ConfirmDeleteModal } from '../modals/modal-ConfirmDelete';
import { getAllOrgsApi } from '../api/api-organizations';
import { EditUserModal } from '../modals/modal-EditUser';
import { PromiseHelper } from '../classes/promiseHelper';
import { getUserName, hasAdminRole, hasDistributorRole, getCurrentUser } from '../api/api-account';

interface State {
  usersData: userInfo[]
  editModalOpen: boolean,
  addModalOpen: boolean,
  deleteModalOpen: boolean,
  orgOptions: DropdownList[],
}

export interface Props {
}


export class UsersPage extends React.Component<Props, State> {

  private orgList: orgInfo[];
  private adminIndex: number = -2;
  private currentOrgIndex: number = -3;
  private editData:userInfo = getDefaultUserInfo();
  private currentUser:userInfo = getDefaultUserInfo();

  getPromise: PromiseHelper<userInfo[]> = new PromiseHelper();
  addPromise: PromiseHelper<userInfo> = new PromiseHelper();
  editPromise: PromiseHelper<userInfo> = new PromiseHelper();
  deletePromise: PromiseHelper<boolean> = new PromiseHelper();
  orgPromise: PromiseHelper<orgInfo[]> = new PromiseHelper();

  constructor(props: Props) {
    super(props);
    this.orgList = [];
    this.state = {
      usersData: [getDefaultUserInfo()],
      addModalOpen: false,
      editModalOpen: false,
      deleteModalOpen: false,
      orgOptions: [],
    }
  }

  componentDidMount() {
    this.getUsersApiCall();getCurrentUser().then(res=>{
      this.currentUser=res!
      if(hasAdminRole()||hasDistributorRole()){
        this.orgPromise.newPromise(getAllOrgsApi(), 
        t => {
          this.orgList = t;
          this.setDropDownOptions(t);
        },
          c => alert(`${c.message} \n ${c.detail}`)
        );
      }
      else{
        let customerOrg:orgInfo =new orgInfo();
          customerOrg.Init({name:this.currentUser.customerName!, id:this.currentUser.customerId, orgType:orgTypes.Customer, distId:this.currentUser.distributorId});
          this.orgList=[customerOrg];
          this.setState({orgOptions: [{name:customerOrg.name,value:0}]});
      }
    });
  }

  componentWillUnmount() {
    this.getPromise.clearPromise();
    this.addPromise.clearPromise();
    this.editPromise.clearPromise();
    this.deletePromise.clearPromise();
    this.orgPromise.clearPromise();
  }

  // Given an array of arrays, set the values as the drop down options:
  //TODO: limit this list to orgs that the current org should be able to see
  setDropDownOptions = (value: orgInfo[]) => {
    let cOptions = value.map(c => {
      return { name: c.name, value: value.indexOf(c) };
    });
    if(hasAdminRole()){
      cOptions.unshift({ name: "Admin Web User", value: this.adminIndex })
    }
    else if(hasDistributorRole()){
      cOptions.unshift({name:this.currentUser.distributorName!, value:this.currentOrgIndex});
    }
    else{
      cOptions.unshift({name:this.currentUser.customerName!, value:this.currentOrgIndex});
    }
    
    cOptions.unshift({ name: "Select...", value: -1 });
    this.setState({
      orgOptions: cOptions,
    });
  };

  render() {
    return (
      <React.Fragment>
        <Header />

        <div className="d-flex align-items-center header-page-title nav-divider">
          <div className="m-2 ml-3 mr-auto">
            Users
          </div>
          <div className="col-10 d-flex justify-content-end align-items-center">
            <div>
              <button
                className="btn btn-outline-secondary m-2 justify-content-right button-standard"
                onClick={this.handleAdd}
              >
                + Add User
              </button>
              <AddUserModal
                isModalOpen={this.state.addModalOpen}
                closeModal={this.closeModal}
                addUser={this.addUser}
                orgOptions={this.state.orgOptions}
              />
            </div>
          </div>
        </div>

        <div className="ReactTable component-standard">
          <ReactTable
            data={this.state.usersData}
            filterable={true}
            defaultFilterMethod={(filter, row) => (matchSorter([row[filter.id]], filter.value).length !== 0)}
            showPagination={this.state.usersData.length>20}
            minRows={10}
            // COLUMNS ////////////////////////////////
            columns={
              [
                {
                  Header: 'First Name',
                  accessor: 'firstName',
                  headerStyle: TableStyles.columnHeaderStyle,
                  style: TableStyles.dataStyle,
                  minWidth: 200
                }, {
                  Header: 'Last Name',
                  accessor: 'lastName',
                  headerStyle: TableStyles.columnHeaderStyle,
                  style: TableStyles.dataStyle,
                  minWidth: 200
                }, {
                  Header: 'Organization',
                  headerStyle: TableStyles.columnHeaderStyle,
                  style: TableStyles.dataStyle,
                  minWidth: 200,
                  Cell: cell => (
                    this.getOrgName(cell.original)
                  )
                }, {
                  Header: 'Phone',
                  accessor: 'phone',
                  headerStyle: TableStyles.columnHeaderStyle,
                  style: TableStyles.dataStyle,
                  minWidth: 120
                }, {
                  Header: 'Email',
                  accessor: 'email',
                  headerStyle: TableStyles.columnHeaderStyle,
                  style: TableStyles.dataStyle,
                  minWidth: 200

                }, {
                  Header: 'Role',
                  accessor: 'role',
                  headerStyle: TableStyles.columnHeaderStyle,
                  style: TableStyles.dataStyle,
                  minWidth: 100,
                }, {
                  Header: '',
                  width: 112,
                  sortable: false,
                  filterable: false,
                  show: true, //isOwnerRole(),
                  Cell: cell => (
                    getUserName()!==cell.original.email &&
                    <div>
                      <button className="iconButton"
                        onClick={() => {
                          this.editData=cell.original;
                          this.setState({
                            editModalOpen: true,
                          })
                        }}
                        disabled={getUserName()===cell.original.email}
                      >
                        <FontAwesomeIcon icon={faPencilAlt} />
                      </button>
                      <button className="iconButton"
                        onClick={() => {
                          this.editData=cell.original;
                          this.setState({
                            deleteModalOpen: true,
                          })
                        }}
                        disabled={getUserName()===cell.original.email}
                      >
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </button>
                    </div>
                  )
                },
              ]}
            // COLUMNS END //////////////////
            className="-highlight"
          />
        </div>
          <React.Fragment>
            <EditUserModal
              isModalOpen={this.state.editModalOpen}
              closeModal={this.closeModal}
              userInfo={this.editData}
              orgOptions={this.state.orgOptions}
              editUser={this.editUser}
              orgIndex={this.orgList.findIndex(x=>x.name===(
                this.editData.customerName==null
                ?this.editData.distributorName
                :this.editData.customerName))}
            />

            <ConfirmDeleteModal
              isModalOpen={this.state.deleteModalOpen}
              closeModal={this.closeModal}
              confirmInfo={this.editData.firstName + " " + this.editData.lastName}
              deleteInfo={this.deleteUser}
            />
          </React.Fragment>
      </React.Fragment>
    )
  }

  private getUsersApiCall = () => {
    this.getPromise!.newPromise(
      userApi.getUsersApi(), result => {
        if (result) {
          this.setState({
            ...this.state,
            usersData: result
          });
        }
      },
      e => {
        console.log(`Error caught in page-users.GetUsers(). ${e!.message}`);
        alert('Error getting Users.');
      }
    )
  }

  private deleteUser = () => {
    this.deletePromise!.newPromise(
      userApi.deleteUserApi(this.editData),
      _ => {
        this.getUsersApiCall();
      },
      e => {
        console.log(`Error caught in page-users.DeleteUser(). ${e!.message}`);
        alert('Error deleting user.');
      }
    )
  }

  private addUser = (userInfo: userInfo, orgIndex: number) => {
    this.setUserRoleAndOrgId(userInfo, orgIndex);

    let newUser: registerUserInfo = {
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
      phone: userInfo.phone,
      email: userInfo.email,
      customerId: userInfo.customerId,
      distributorId: userInfo.distributorId,
      roles: userInfo.roles,
    };

    this.addPromise!.newPromise(
      userApi.addUserApi(newUser),
      result => {
        this.setState({addModalOpen: false});
        this.getUsersApiCall();
      },
      e => {
        console.log(`Error caught in page-users.AddUser(). ${e!.message}`);
        alert('Error adding user.');
      }
    )
  }

  private editUser = (userInfo: userInfo, orgIndex: number) => {
    this.setUserRoleAndOrgId(userInfo, orgIndex);

    this.editPromise!.newPromise(
      userApi.editUserApi(userInfo),
      result => {
        this.getUsersApiCall();
      },
      e => {
        console.log(`Error caught in page-users.EditUser(). ${e!.message}`);
        alert('Error editing user.');
      }
    )
  }

  private setUserRoleAndOrgId = (user: userInfo, orgIndex: number) => {
    if (orgIndex >= 0) {
      let org: orgInfo = this.orgList[orgIndex];
      if (org.orgType === orgTypes.Customer) {
        user.customerId = org.id;
        user.roles = ["customer"];
      }
      else if (org.orgType === orgTypes.Distributor) {
        user.distributorId = org.id;
        user.roles = ["distributor"];
      }
    }
    else if (orgIndex===this.adminIndex){
      user.distributorId = null;
        user.customerId = null;
        user.roles = ["admin"];
    }
    else if (orgIndex===this.currentOrgIndex){
      user.distributorId=this.currentUser.distributorId;
      user.customerId=this.currentUser.customerId;
      if(hasDistributorRole()){
        user.roles = ["distributor"];
      }else{
        user.roles = ["customer"];
      }
    }
  }

  handleAdd = () => {
    this.setState({
      addModalOpen: true
    });
  }

  private closeModal = () => {
    this.setState({
      ...this.state,
      addModalOpen: false,
      editModalOpen: false,
      deleteModalOpen: false
    });
    this.getUsersApiCall();
  }

  private getOrgName = (user: userInfo) => {
    if (user.customerId !== null) {
      return user.customerName;
    }
    else if (user.customerId === null && user.distributorId !== null) {
      return user.distributorName;
    }
    else {
      return 'N/A';
    }
  }

}